import { LabelHTMLAttributes } from 'react';

import StyledInputLabel from './InputLabel.styled';

type InputLabelProps = LabelHTMLAttributes<HTMLLabelElement>;

const InputLabel: React.FC<InputLabelProps> = props => <StyledInputLabel {...props} />;

export default InputLabel;
